/**
 * The caveat under a chart whose converted totals are nearest-available
 * rather than exact: a closed deal from before the exchange-rate feed
 * started converts at the earliest rate the feed has. Quiet by design —
 * the figures are still the best available answer, not an error.
 *
 * Sized to `EARLIEST_RATE_NOTE_HEIGHT` (earliestRateConversion.ts); the two
 * must move together.
 */
export function EarliestRateNote() {
  return (
    <p
      role='note'
      className='mt-1 h-4 truncate text-xs leading-4 text-fg-tertiary'
    >
      Some amounts converted at the earliest available exchange rate.
    </p>
  );
}
